import { SET_DASHBOARD_DATA } from '../constants/dashboard';

const DEFAULT_STATE = {
  loading: false,
  feedData: [],
  tripData: []
};

export default (state = DEFAULT_STATE, action) => {
  const { type, payload = {} } = action;
  switch (type) {
    case SET_DASHBOARD_DATA: {
      return { ...state, ...payload };
    }
    default:
      return state;
  }
};
